<div class="nt-loading-shade-middle" *ngIf="loading">
  <mat-spinner color="primary" *ngIf="loading"></mat-spinner>
</div>

<div class="wrapper public-wrapper">
  <!-- top navbar-->
  <app-public-header class="topnavbar-wrapper"></app-public-header>
  <!-- Main section-->
  <section class="section-container public-section">
    <!-- Page content-->
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </section>
  <!-- Page footer-->
  <footer class="footer-container" app-footer></footer>
  <app-cookies-banner></app-cookies-banner>
</div>
